// This file should only contain action type constants.

export const SET_DL_ITEMS = 'SET_DL_ITEMS';
